<template>
  <div
    v-on-display="{ sectionInfo, context: this }"
    class="multi highlight-band"
    :style="'background-image:url(' + blurImage + ')'"
  >
    <div class="highlight-band-meta">
      <!-- text title -->
      <h1 tabindex="0" class="highlight-band-txt">
        <span v-if="hasTitle(0)">{{ getTitleText(0) }}</span>
        <span v-if="hasTitle(1)">{{ getTitleText(1) }}</span>
      </h1>
      <!-- img title
      <h1 tabindex="0" class="highlight-band-img">
        <img src="https://www.wavve.com/img/ci-wavve.5b304973.svg" :alt="getTitleText(0) + ' ' + getTitleText(1)">
      </h1>
      -->
      <div class="highlight-band-subtitle">
        <p v-if="hasTitle(2)">{{ getTitleText(2) }}</p>
        <p v-if="hasTitle(3)">{{ getTitleText(3) }}</p>
      </div>
      <a
        href="#"
        class="highlight-band-more"
        @click.prevent="viewMore(sectionInfo)"
        >{{ cta }}</a
      >
    </div>
    <div class="highlight-band-multi">
      <cell-list
        v-if="cellList.length > 0"
        :cell-list="cellList"
        :thumbnail-info="thumbnailInfo"
        cell-type="band_highlight"
      ></cell-list>
    </div>
  </div>
</template>
<script>
  import { onDisplay } from '@/common/resources/directives'
  import _ from 'lodash'
  import { fetchOnContent } from '@/common/utils/request.common'
  import { getBand, getCellList } from '@/common/utils/gnb.fp'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import { getThumbnailInfo } from '@/common/utils/common'
  import CellList from '@/components/band/CellList'
  import { resizeThumbnail } from '@/common/utils/image'
  export default {
    name: 'HighlightBand',
    components: {
      CellList,
    },
    directives: {
      onDisplay,
    },
    mixins: [MultiSectionMixin],
    props: {
      sectionInfo: {
        type: Object,
      },
    },
    data() {
      return {
        cellList: [],
        cta: '더보기',
        titleList: [],
        bandInfo: {},
        cellTopList: {},
        blurImage: '',
        thumbnailInfo: {},
      }
    },
    created() {
      this.setData()
    },
    methods: {
      async setData() {
        const response = await fetchOnContent(this.sectionInfo)
        this.bandInfo = getBand(response)
        this.cellList = getCellList(response)
        this.cta = _.get(response, 'data.cell_toplist.cta', '더보기')
        this.titleList = _.get(response, 'data.cell_toplist.title_list', [])
        this.thumbnailInfo = getThumbnailInfo('band_14')
        this.blurImage = resizeThumbnail(
          _.get(response, 'data.cell_toplist.blurtarget_img', ''),
          { width: 1240, height: 444, option: 'b20', quality: 100 },
        )

        this.thumbnailInfo.type = 'band_highlight'
      },
      getTitleText(index) {
        return _.get(this.titleList, `${index}.text`, '')
      },
      hasTitle(index) {
        return this.getTitleText(index) !== ''
      },
    },
  }
</script>
